import React from 'react';
import {Container, Button, Row, Col} from "react-bootstrap";
import {HashLink} from 'react-router-hash-link';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowCircleUp} from '@fortawesome/free-solid-svg-icons';
import '../styles/components/floattingbuttons.css';

export const FloattingButtons = () => {
  return (
    <Container id="floattingButtons" className="d-none d-md-block" fluid>
      <Row className="mb-3">
          <Col className="text-right">
            <HashLink to ="#">
              <Button className="fablab-button"><FontAwesomeIcon icon={faArrowCircleUp} className="mr-2"/> Subir</Button>
            </HashLink>
          </Col>
        </Row>        
    </Container>
  )
}
